// eslint-disable-next-line max-classes-per-file
import LogRocket from 'logrocket';

import { getPlanName } from '@genially/commons';

import type { UserData } from '../../UserData';
import { LogRocketAnonymousIntegration } from './LogRocketAnonymousIntegration';

export class LogRocketIntegration extends LogRocketAnonymousIntegration {
  public constructor(private userData: UserData) {
    super();
  }

  start(): void {
    const userData = {
      name: `${this.userData.firstName} ${this.userData.lastName}`,
      email: this.userData.userName,
      // Add your own custom user variables here, ie:
      subscriptionType: this.userData['User Subscription'],
      role: this.userData.Role,
      sector: this.userData.Sector,
      workspacePlan: this.userData.TeamType ? getPlanName(this.userData.TeamType) : '',
    };

    LogRocket.identify(this.userData.id, userData);

    this.log('Initialized', { userData });
  }
}
